import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const EnglishLiteraryClub = () => {
    useEffect(() => {
        document.title = 'English Literary Club -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>English Literary Club </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                           
                            <li>|</li>
                            <li> English Literary Club </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'> 
                <div className="row sports"> 
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Eng-club1.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Eng-club1.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Eng-club2.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Eng-club2.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Eng-club3.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Eng-club3.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div> 
            </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default EnglishLiteraryClub